import React, { useState, useEffect } from 'react';
import {
  Container,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormControl,
  TextField,
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  FormGroup,
  Button,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import { useStyles } from '../../components/Styles';
import DateFnsUtils from '@date-io/date-fns';
import { ParseIso, format } from 'date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import moment from 'moment';
import ReportContainer from '../../components/ReportComponent/ReportContainer';
import CashGraph from './components/CashGraph';

function CashFlow() {
  const [locale, setLocale] = React.useState('pt');
  const [beginDate, handleBaginDate] = useState(moment().locale('pt-BR').subtract(30, 'days').format('yyyy-MM-DD'));
  const [endDate, handleEndDate] = useState(moment().locale('pt-BR').format('yyyy-MM-DD'));

  return (
    <ReportContainer title="Fluxo de Caixa">
      <Container>
        <FormGroup>
          <Grid container spacing={3} justifyContent="center" alignItems="center">
            <Grid item xs={12} sm={6} md={4}>
              <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
                <DatePicker
                  fullWidth
                  InputLabelProps={{ style: { pointerEvents: 'auto' }, shrink: true }}
                  label="Data inicial"
                  name="begin"
                  variant="inline"
                  inputVariant="outlined"
                  invalidDateMessage="Data Inválida"
                  value={beginDate}
                  onChange={(date) => {
                      handleBaginDate(date);
                    }}
                  format="dd/MM/yyyy"
                                    // inputFormat="DD/MM/YYYY"
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
                <DatePicker
                  fullWidth
                  InputLabelProps={{ style: { pointerEvents: 'auto' }, shrink: true }}
                  label="Data Final"
                  name="end"
                  variant="inline"
                  inputVariant="outlined"
                  invalidDateMessage="Data Inválida"
                  value={endDate}
                  onChange={(date) => {
                      handleEndDate(date);
                    }}
                  format="dd/MM/yyyy"
                                    // inputFormat="DD/MM/YYYY"
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => {
                  // getReport()
                }}
                size="large"
              >
                Gerar
              </Button>
            </Grid>
          </Grid>
        </FormGroup>

      </Container>
      <br />
      <Container>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={5}>
            algum grafico aqui
          </Grid>
          <Grid item xs={12} sm={7}>
            <Card variant="outlined">
              <CardContent>
                <Typography align="center" color="textSecondary" gutterBottom>
                  grafíco de {beginDate}
                  {' '}
                  até{endDate}
                </Typography>
                <CashGraph />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </ReportContainer>
  );
}

export default CashFlow;
